import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDecreasingNeed = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "decreasingNeed",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13059",
			"data-name": "Path 13059",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13060",
			"data-name": "Path 13060",
			d: "M5,7l5.071,5.071a1,1,0,0,0,1.414,0L13.626,9.93a1,1,0,0,1,1.414,0L21,15.889",
			transform: "translate(0 0)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13062",
			"data-name": "Path 13062",
			d: "M5,7l5.071,5.071a1,1,0,0,0,1.414,0L13.626,9.93a1,1,0,0,1,1.414,0L21,15.889",
			transform: "translate(0 4)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13061",
			"data-name": "Path 13061",
			d: "M21,9.667V7",
			transform: "translate(0 6.222)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13063",
			"data-name": "Path 13063",
			d: "M18.333,9.667H21",
			transform: "translate(0 10.222)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgDecreasingNeed;
